<template>
  <a-layout class="create-application-box">
    <a-card class="create-application" :bordered=false>
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
      </div>
      <!-- <div slot="extra" style="cursor:pointer" v-if="pageLayout.introduction">
        <span @click="introductionVisible=true">
          <a-icon type="exclamation-circle" />{{pageLayout.introduction.title}}</span>
      </div> -->
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && loadedLayout">
        <common-form v-if="layout.type==='commonForm'" :ref="`commonForm_${layout.field}`" :layout="layout" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange" @update="update" @event-relay="eventRelay" @current-changed-field="getCurrentChanged"></common-form>
        <multi-form :ref="`multiForm_${layout.field}`" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" :field-path="layout.field" :default-params="defaultParams" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange" @update="update"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" @changed-fields="setSummationInfo"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :default-file-none="defaultFillNone" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" @changed-fields="onFieldChange"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'必填信息填写后，流程将自动显示'" v-if="loadedInfo && loadedLayout"></approval-flow>
      <a-row style="margin:30px 0 24px;" v-if="loadedInfo && loadedLayout">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="10">
          <a-button type="primary" :disabled="!canSubmit" @click="submit" style="width:120px;">提交</a-button>
        </a-col>
      </a-row>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-modal class="introductionModal" :title="pageLayout.introduction.title" v-if="pageLayout.introduction" v-model="introductionVisible" @ok="introductionVisible=false" :okText="'关闭'">
        <div>
          <pre style="font-size: 14px;color: rgba(0,0,0,0.65);line-height: 22px;text-align:left">{{pageLayout.introduction.description}}</pre>
        </div>
      </a-modal>
    </a-card>
  </a-layout>
</template>

<script>
import UUID from 'uuidjs';
import SvgIcAll from '../../assets/svg/ic-all-o.svg';
import CommonForm from '../../components/CommonForm.vue';
import MultiForm from '../../components/MultiForm.vue';
import Summation from '../../components/Summation.vue';
import ApprovalFlow from '../../components/ApprovalFlow.vue';
import Upload from '../../components/Upload.vue';
import { setTimeout } from 'timers';
import LayoutConfig from '../../utils/LayoutConfig.js';
import {
  layoutConfig1,
  layoutConfig2,
  layoutConfig3,
} from '../../utils/mockData.js';
import {
  getProPaymentLayout,
  getCreateProPaymentParams,
  getProPaymentEditParams,
  submitProPayment,
  getProPaymentFlow,
} from '../../services/CommonService.js';

export default {
  components: {
    SvgIcAll,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    Upload,
  },
  data() {
    return {
      defaultFillNone: false,
      introductionVisible: false,
      canEdit: true,
      breadcrumb: [
        {
          label: '发起申请',
          path: {
            name: 'launchApplication',
          },
        },
        {
          label: '项目付款申请',
          path: '',
        },
      ],
      cardHeight: 0,
      applicationTitle: '发起付款申请',
      params: {},
      defaultParams: {}, // 复制时需要用到创建用到的默认参数
      loadedLayout: false,
      // loadedLayout: true,
      loadedInfo: false,
      initDeafultInfo: false,
      canSubmit: true,
      pageLayout: {},
      // pageLayout: layoutConfig,
      approvalFlowInfo: [],
      summationInfo: {},
      requestParams: {},
      cancelSource: null,
    };
  },

  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      // 复制时清空附件
      this.defaultFillNone = true;
      Promise.all([this.getProPaymentEditParams()]).then(() => {
        this.fetchPageLayout(this.params.basicInfo.provide_invoices);
        this.getPaymentDefaultInfo();
      });
    } else {
      Promise.all([this.getPaymentCache()]).then(() => {
        this.fetchPageLayout(this.params.basicInfo.provide_invoices);
        this.getPaymentDefaultInfo();
      });
    }
  },
  mounted() {
    if (!this.$route.query.id) {
      this.systemCacheTimer = setInterval(this.systemCache, 20000);
    }
  },
  beforeDestroy() {
    clearInterval(this.systemCacheTimer);
  },

  computed: {
    approvalFlowDependParams() {
      const params = _.cloneDeep(this.requestParams);
      if (this.requestParams.basicInfo && this.requestParams.total_pay) {
        return {
          project_id: this.requestParams.basicInfo.project_id,
          company_id: this.requestParams.basicInfo.company_id,
          total_pay: this.requestParams.total_pay,
        };
      }
    },
  },

  methods: {
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      LayoutConfig.setAllParams(this.params);
      this.requestParams = _.cloneDeep(this.params);
    },
    setSummationInfo(e) {
      this.summationInfo = e;
      this.requestParams = _.cloneDeep(this.params);
      this.requestParams = Object.assign(
        this.requestParams,
        this.summationInfo,
      );
    },
    fetchPageLayout(provide_invoices = 1) {
      this.loadedLayout = false;
      getProPaymentLayout({
        id: this.$route.query.id,
        type: 'create',
        provide_invoices: provide_invoices,
        ding_msg_switch:
          window.location.href.indexOf('fromLocation=msg') !== -1 ? 1 : 0,
      }).then(res => {
        if (res.status === 'success') {
          this.pageLayout = res.data;
        } else {
          this.$Message.error(res.message);
        }
        this.loadedLayout = true;
      });
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      this.cancelQuest();
      getProPaymentFlow(this.requestParams, this).then(res => {
        if (res.status === 'success') {
          if (res.data && _.isArray(res.data)) {
            res.data.forEach((item, index) => {
              this.$set(this.approvalFlowInfo, index, item);
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    // 获取复制单详情
    getProPaymentEditParams() {
      this.loadedInfo = false;
      return getProPaymentEditParams(this.$route.query.id).then(res => {
        if (res.status === 'success') {
          this.paramsBackup = _.cloneDeep(res.data);
          this.params.init = false;
          this.loadedInfo = true;
          this.params = Object.assign({}, this.params, res.data);
          LayoutConfig.setAllParams(this.params);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    // 获取创建时表单缓存
    getPaymentCache() {
      this.loadedInfo = false;
      return getCreateProPaymentParams({
        type: 'cache',
      }).then(res => {
        if (res.status === 'success') {
          this.paramsBackup = _.cloneDeep(res.data);
          this.params.init = false;
          this.loadedInfo = true;
          this.params = Object.assign({}, this.params, res.data);
          LayoutConfig.setAllParams(this.params);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    // 获取创建时表单默认值
    getPaymentDefaultInfo() {
      this.initDeafultInfo = false;
      getCreateProPaymentParams({
        type: 'default',
        provide_invoices: this.params.basicInfo.provide_invoices,
      }).then(res => {
        if (res.status === 'success') {
          this.defaultParams = Object.assign({}, this.defaultParams, res.data);
          this.initDeafultInfo = true;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    submit() {
      let validateResult = true;
      Object.keys(this.$refs).forEach(key => {
        if (key.indexOf('commonForm') || key.indexOf('multiForm')) {
          this.$refs[key].forEach(item => {
            if (!item.validateFields()) {
              validateResult = false;
            }
          });
        }
      });
      if (validateResult) {
        this.canSubmit = false;
        delete this.requestParams.system_cache;
        clearInterval(this.systemCacheTimer);
        submitProPayment(this.requestParams).then(res => {
          if (res.status === 'success') {
            this.$Message.success('创建申请成功');
            this.$router.replace({
              name: 'myApplicationList',
              query: {
                apply_type: 8,
              },
            });
          } else {
            this.$Message.error(res.message);
            this.systemCacheTimer = setInterval(this.systemCache, 20000);
          }
          this.canSubmit = true;
        });
      }
    },
    systemCache() {
      if (this.loadedInfo && this.loadedLayout) {
        submitProPayment({ ...this.requestParams, system_cache: true }).then(
          res => {},
        );
      }
    },
    update(e) {
      this.fetchLayout();
    },
    back() {
      this.$router.replace({
        name: 'launchApplication',
      });
    },
    getNeighorByField(val) {
      let vm = null;
      Object.keys(this.$refs).forEach(key => {
        const field = key.substr(key.indexOf('_') + 1);
        if (field === val) {
          vm = this.$refs[key];
        }
      });
      return vm[0];
    },
    eventRelay(e) {
      const self_event = e[0];
      let behind_event = _.cloneDeep(e);
      behind_event.shift();
      if (self_event.selfDo === 'emit') {
        this.$emit('event-relay', behind_event);
      } else if (self_event.selfDo === 'passNeighor') {
        let neighorVm = this.getNeighorByField(self_event.params.value);
        neighorVm.eventRelay(behind_event);
      }
    },
    cancelQuest() {
      if (typeof this.cancelSource === 'function') {
        this.cancelSource('终止请求'); //取消请求
      }
    },
    getCurrentChanged(e) {
      if (Object.keys(e)[0] === 'provide_invoices') {
        this.params.detailInfo.forEach((item, index) => {
          this.updateFormDetailConfig(index, 1); // 第二个参数用来标识是否更新新增明细时的默认值和默认布局;
        });
      }
    },
    updateFormDetailConfig(detail_index, default_flag = 0) {
      getCreateProPaymentParams({
        type: 'default',
        provide_invoices: this.params.basicInfo.provide_invoices,
      }).then(res => {
        const currentDefaultParams = res.data.detailInfo
          ? res.data.detailInfo
          : [{}];
        if (default_flag && detail_index === 0) {
          // 为后面新增明细的操作以第一条明细参数为模板
          this.defaultParams = res.data;
        }
        getProPaymentLayout({
          type: 'create',
          provide_invoices: this.params.basicInfo.provide_invoices,
          ding_msg_switch:
            window.location.href.indexOf('fromLocation=msg') !== -1 ? 1 : 0,
        }).then(result => {
          if (result.status === 'success') {
            if (default_flag && detail_index === 0) {
              // 为后面新增明细的操作以第一条明细布局为模板
              let multiFormConfig = this.pageLayout.contents.find(
                item => item.type === 'multiForm',
              );
              multiFormConfig.contents = result.data.contents.find(
                item => item.type === 'multiForm',
              ).contents;
            }
            this.$refs.multiForm_detailInfo.forEach(item => {
              item.refreshFormConfig(
                detail_index,
                result.data.contents.find(item => item.type === 'multiForm')
                  .contents,
                currentDefaultParams,
              );
            });
          } else {
            this.$Message.error(result.message);
          }
        });
      });
    },
  },
  watch: {
    approvalFlowDependParams: {
      handler(val) {
        if (
          val &&
          val.project_id &&
          val.company_id &&
          val.total_pay &&
          val.total_pay !== '0.00'
        ) {
          this.copyVal = _.cloneDeep(val);
          this.fetchApprovalFlow();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less">
.create-application-box {
  padding: 16px;
}
.introductionModal {
  .ant-modal-footer {
    .ant-btn-default {
      display: none;
    }
  }
}
</style>
